window.addEventListener("DOMContentLoaded", () => {
	// Mobile Nav
	document.querySelector(".hamburger").onclick = function() {
        document.querySelector("body").classList.toggle("menu-open");
    };
    

    let main_nav = document.querySelector('.main-nav')
    if(main_nav){
        
        let main_items = main_nav.querySelectorAll('.nav-main-item')
        main_items.forEach(main_item =>{
            let nav_drop = main_item.querySelector('.nav-drop')
            if(nav_drop){
                //get nav drop height
                getHeight(nav_drop)

                //get sub nav drop height
                let sub_nav_drop = nav_drop.querySelector('.sub-category-wrapper')
                if(sub_nav_drop){
                    getHeight(sub_nav_drop)
                }

                let pluses = main_item.querySelectorAll('.plus')
                pluses.forEach(plus =>{
                    // console.log(plus.parentElement)
                    plus.addEventListener('click',()=>{
                        plus.parentElement.classList.toggle('active')
                        if(plus.parentElement.classList.contains('nav-drop-item')){
                            // console.log(plus)
                            let nav_drop_item = plus.parentElement;
                            let old_nav_drop_height = nav_drop.scrollHeight;
                            let sub_nav_drop_height = nav_drop_item.querySelector('.sub-category-wrapper').scrollHeight;
                            if(nav_drop_item.classList.contains('active')){
                                plus.parentElement.parentElement.setAttribute('style',`--tooltip-height: ${old_nav_drop_height + sub_nav_drop_height}px`)
                            }
                            else{
                                plus.parentElement.parentElement.setAttribute('style',`--tooltip-height: ${old_nav_drop_height - sub_nav_drop_height}px`)
                            }
                            
                        }
                    })
                })
            }
            
        })
        
    }
    function getHeight(el){
        el.style.height = "auto"
        el.setAttribute('style', `--tooltip-height: ${el.scrollHeight}px`)

        window.addEventListener('resize', ()=>{
            el.style.height = "auto"
            el.setAttribute('style', `--tooltip-height: ${el.scrollHeight}px`)
        })
    }
    
});

